import { formatCurrency } from './formatMoeda';

export function calculateTotal(quantidade, vlrUnit) {
  const quantidadeNum = parseFloat(quantidade) || 0;
  const vlrUnitNum = vlrUnit || 0;
  return formatCurrency(quantidadeNum * vlrUnitNum);
}
